"use strict";

// Galerie Produits: filtres catégorie / sous-catégorie

function wait(duration) {
	return new Promise(function(resolve) {
		setTimeout(resolve, duration);
	});
}

function debounce(callback, delay) {
	let timeout = null;

	return function() {
		clearTimeout(timeout);

		timeout = setTimeout(function() {
			callback();
		}, delay);
	};
}

function filterProducts() {
	const productsContainer = $('.all-products-ctn');
	const productsWrapper = productsContainer.find('.all-products').get(0);

	if (!productsWrapper) return;

	const searchTerm = $('#search-input').val().toLowerCase().trim();
	const activeGroups = getActiveCategoryGroups();

	productsContainer.addClass('--loading');
	productsWrapper.classList.add('--transitioning');

	wait(600).then(function() {
		animateProductsContainerHeight(function() {
			let visibleProductsCount = 0;

			$('.products-grid .product-card').each(function() {
				const product = this;
				const title = $(product).find('.product-info .title').text().toLowerCase();
				const searchMatch = searchTerm === '' || title.includes(searchTerm);
				const categoryMatch = productMatchesCategoryFilters(product, activeGroups);

				if (searchMatch && categoryMatch) {
					product.classList.remove('--hidden');
					visibleProductsCount++;
				} else {
					product.classList.add('--hidden');
				}
			});

			const productsGrid = $('.products-grid');

			if (visibleProductsCount === 0) {
				productsGrid.addClass('--hidden');
				$('.no-products').addClass('--is-visible');
			} else {
				productsGrid.removeClass('--hidden');
				$('.no-products').removeClass('--is-visible');
			}
		});
	});

	wait(1200).then(function() {
		productsContainer.removeClass('--loading');
		productsWrapper.classList.remove('--transitioning');
	});
}

function getActiveCategoryGroups() {
	const groups = [];

	$('.module-categories-filters .category-group').each(function() {
		const $group = $(this);
		const categoryId = String($group.attr('data-category-id'));
		const $checked = $group.find('.checkbox-group input:checked');

		if (!$checked.length) {
			return;
		}

		const hasAll = $checked.filter('[value="all"]').length > 0;
		const subcategoryIds = $checked
			.map(function() {
				return this.value !== 'all' ? String(this.value) : null;
			})
			.get()
			.filter(Boolean);

		groups.push({
			categoryId: categoryId,
			all: hasAll,
			subcategoryIds: subcategoryIds
		});
	});

	return groups;
}

function productMatchesCategoryFilters(product, activeGroups) {
	if (!activeGroups.length) {
		return true;
	}

	const productCategory = String(product.dataset.category || '');
	const productSubcategory = String(product.dataset.subcategory || '');

	return activeGroups.some(function(group) {
		if (productCategory !== group.categoryId) {
			return false;
		}

		if (group.all || group.subcategoryIds.length === 0) {
			return true;
		}

		return group.subcategoryIds.indexOf(productSubcategory) !== -1;
	});
}

function syncCategoryCheckboxes($changedInput) {
	const $group = $changedInput.closest('.category-group');
	const $all = $group.find('input[value="all"]');
	const $subcategories = $group.find('input').not('[value="all"]');
	const changedValue = $changedInput.val();
	const isChecked = $changedInput.is(':checked');

	if (changedValue === 'all') {
		if (isChecked) {
			$subcategories.prop('checked', false);
		}
		return;
	}

	if (isChecked) {
		$all.prop('checked', false);
	}
}

function animateProductsContainerHeight(callback) {
	const container = document.querySelector('.all-products-ctn');
	const content = document.querySelector('.all-products');

	if (!container || !content) {
		if (typeof callback === 'function') callback();
		return;
	}

	container.style.transition = 'none';
	container.style.height = container.offsetHeight + 'px';
	container.offsetHeight;
	container.style.transition = 'height 0.4s ease';

	if (typeof callback === 'function') callback();

	const endHeight = content.scrollHeight;

	requestAnimationFrame(function() {
		container.style.height = endHeight + 'px';
	});

	const onTransitionEnd = function(event) {
		if (event.propertyName !== 'height') return;

		container.style.height = 'auto';
		container.removeEventListener('transitionend', onTransitionEnd);
	};

	container.addEventListener('transitionend', onTransitionEnd);
}

const debouncedFilterProducts = debounce(function() {
	filterProducts();
}, 300);

$(document).ready(function() {
	const categoriesFilter = $('.module-categories-filters');
	const firstFilter = categoriesFilter.find('.category-group').get(0);

	if (firstFilter) {
		firstFilter.classList.add('--is-open');
	}

	const toggleElements = ['.open-filters', '.module-categories-filters .header', '.filters-backdrop'];
	toggleElements.forEach(function(selector) {
		const element = document.querySelector(selector);
		if (!element) return;

		element.addEventListener('click', function() {
			categoriesFilter.toggleClass('--is-open');
		});
	});

	$('.category-header').on('click', function() {
		$(this).closest('.category-group').toggleClass('--is-open');
	});

	$('.module-categories-filters .checkbox-group input').on('change', function() {
		syncCategoryCheckboxes($(this));
		filterProducts();
	});
	$('#search-input').on('keyup', debouncedFilterProducts);
});
